import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/questionnaire`;

export const getQuestionApi = async () => {
    try {
        const response = await fetch(url, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error("Failed to fetch product data. Please try again.");
        }
        const data = await response.json();
        const getQueData = data.data?.map((item) => {
            if (item?.type === "text") {
                return {
                    id: item?._id,
                    question: item?.question,
                    fieldType: { label: item?.type, value: item?.type },
                    score: item.options[0].score,
                    nestedOptions: [],
                };
            } else {
                return {
                    id: item?._id,
                    question: item?.question,
                    fieldType: {
                        label:
                            item?.type === "single-choice" ? "Single Select" : item?.type,
                        value: item?.type,
                    },
                    nestedOptions: item.options?.map(({ name, score }) => ({
                        Option: name,
                        score: score,
                    })),
                };
            }
        });
        return getQueData
    } catch (error) {
        console.error("Error fetching product data:", error);
    }
};

export const deleteQuestionApi = async (queId, getProductList, setUserDeleteCloseModel) => {
    try {
        const bodyId = { id: queId };
        const response = await fetch(
            url,
            {
                method: "DELETE",
                "Content-Type": "application/json",
                body: JSON.stringify(bodyId),
            }
        );

        if (response.ok) {
            const responseData = await response.json();
            getProductList();
            toast.success(
                responseData?.message || "Question is deleted successfully!"
            );
            setUserDeleteCloseModel();
        } else {
            const data = await response.json();
            toast.error(Object.values(data).join(", ") || "Something went wrong");
            console.error("Failed to submit form");
        }
        return response;
    } catch (error) {
        toast.error("Something went wrong");
        console.error(error, "Error submitting form:");
    }
};

const filterData = (data) => {
    const getData = [...data];
    const updateArry = [];
    const postArry = [];

    getData?.forEach((item) => {
        if (item?.id?.length) {
            updateArry.push(item);
        } else {
            postArry.push(item);
        }
    });
    return {
        updateArry: updateArry,
        postArry: postArry,
    };
};

const updateArryApi = async (data) => {
    const response = await fetch(
        url,
        {
            method: "PATCH",
            body: JSON.stringify(data),
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
            },
        }
    );
    return await response.json();
};

const postArryApi = async (data) => {
    const postData = data?.map(({ question, type, options, extraField }) => ({
        question,
        type,
        options,
        extraField,
    }));
    const response = await fetch(
        url,
        {
            method: "POST",
            body: JSON.stringify(postData),
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
            },
        }
    );

    return await response.json();
};

export const postQuestionApi = async ( form ) => {
    
    try {
        const form_field_value = form.map((fv, i) => {
            if (fv?.fieldType?.value === "text") {
                return {
                    id: fv?.id ? `${fv?.id}`.replaceAll("-", "") : "",
                    question: fv?.question,
                    type: fv?.fieldType?.value,
                    options: [{ name: "text", score: +fv?.score }],
                };
            } else {
                return {
                    id: fv?.id ? `${fv?.id}`.replaceAll("-", "") : "",
                    question: fv?.question,
                    type: fv?.fieldType?.value,
                    options: fv?.nestedOptions?.map(({ Option, score }) => ({
                        score: +score,
                        name: Option?.value,
                    })),
                };
            }
        });

        const { updateArry, postArry } = filterData(form_field_value);

        let errorUpdate = "";
        let errorPost = "";

        if (updateArry?.length) {
            let data1 = await updateArryApi(updateArry);
            if (!data1?.success) {
                errorUpdate = data1?.error;
            }
        }

        if (postArry?.length) {
            let data2 = await postArryApi(postArry);
            if (!data2?.success) {
                errorPost = data2?.error;
            }
        }

        if (errorUpdate && errorPost) {
            toast.error("Failed to update the questions-both");
        } else if (errorUpdate?.length) {
            toast.error("Failed to update the questions-update");
        } else if (errorPost?.length) {
            toast.error("Failed to update the questions-post");
        } else {
            toast.success("Form update successfully");
        }
    } catch (error) {
        console.error(error);
    }
};
